import { Fragment } from 'react';

import OtsOfficialLscBulkRecertifyLargeGrid from './OtsOfficialLscBulkRecertifyLargeGrid';
import OtsOfficialLscBulkRecertifySmallGrid from './OtsOfficialLscBulkRecertifySmallGrid';

const OtsOfficialsLscBulkRecertifyGrid = ({ state, selectedOfficials, onAddOrRemoveLscCertficationForBulkRecertify, onOfficialHistoryReportLoadClick }) => {
  return (
    <Fragment>
      {state.isArrayLoading === false
        ? <div className="row">
          <div className="col-xs-12 col-sm-10">
            <p>{state.arrayData.length === 1 ? `${state.arrayData.length} Search Result` : `${state.arrayData.length} Search Results`}</p>
          </div>
        </div>
        : <Fragment>
          <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          </div>
        </Fragment >}
      <OtsOfficialLscBulkRecertifyLargeGrid
        state={state}
        selectedOfficials={selectedOfficials}
        onAddOrRemoveLscCertficationForBulkRecertify={onAddOrRemoveLscCertficationForBulkRecertify}
        onOfficialHistoryReportLoadClick={onOfficialHistoryReportLoadClick}
      />
      <OtsOfficialLscBulkRecertifySmallGrid
        state={state}
        selectedOfficials={selectedOfficials}
        onAddOrRemoveLscCertficationForBulkRecertify={onAddOrRemoveLscCertficationForBulkRecertify}
        onOfficialHistoryReportLoadClick={onOfficialHistoryReportLoadClick} />
    </Fragment>
  )
};

export default OtsOfficialsLscBulkRecertifyGrid;
